import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "related-cards-header-text" }
const _hoisted_2 = { class: "suggested-related-cards view-results" }
const _hoisted_3 = {
  ref: "viewResultsCards",
  class: "view-results-cards"
}
const _hoisted_4 = ["data-card-id"]

import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import BoardListCard from '@/components/widgets/BoardListCard';
import { globalState } from '@/utilities/globalState';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useTranslate from '@/utilities/composables/useTranslate';
import useNotes from '@/utilities/composables/useNotes';
const SIMILARITY_THRESHOLD = 0.5;


export default /*@__PURE__*/_defineComponent({
  __name: 'RelatedCards',
  props: {
  noteId: {
    type: String,
    required: false,
    default: '',
  },
  templateId: {
    type: String,
    required: false,
    default: '',
  },
},
  setup(__props) {

const store = useStore();
const { iconPath, getCustomIconStyle } = useCustomIcon();
const isExpanded = ref(true);
const { translate } = useTranslate();
const { getAiNote } = useNotes();

const props = __props;

const aiNote = computed(() => getAiNote(props.noteId, props.templateId));

const relatedCardIds = computed(() => {
  return (
    aiNote.value?.related_resources
      ?.map((resource) => {
        if (resource.type !== 'card' || resource.similarity < SIMILARITY_THRESHOLD) return null;
        return resource.id;
      })
      .filter(Boolean) ?? []
  );
});

const relatedCards = computed(() => {
  if (!relatedCardIds.value.length) return [];
  return relatedCardIds.value.map((id) => {
    const card = store.getters.getCardById(id);
    if (Object.keys(card).length === 0) {
      store.dispatch('fetchCard', { cardId: id }).then((a) => {
        store.dispatch('fetchBoard', { boardId: a.board_id });
      });
    }
    return store.getters.getCardById(id);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_vue_scroll = _resolveComponent("vue-scroll")!

  return (relatedCardIds.value.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["related-cards-container", {
      'with-suggested-actions': _unref(globalState).showSuggestedActions,
    }])
      }, [
        _createElementVNode("div", {
          class: "related-cards-header",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpanded.value = !isExpanded.value))
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(relatedCards.value.length) + " " + _toDisplayString(_unref(translate)('relatedCards').toLowerCase()), 1),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("div", null, [
            _createElementVNode("em", {
              class: "custom-icons flex h-4 w-4 ml-1",
              style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)(isExpanded.value ? 'collapse' : 'expand')))
            }, null, 4)
          ])
        ]),
        _cache[2] || (_cache[2] = _createTextVNode()),
        _createElementVNode("div", null, [
          (isExpanded.value)
            ? (_openBlock(), _createBlock(_component_vue_scroll, {
                key: 0,
                class: "cards-layout--list max-h-64 flex flex-col",
                ops: {
          scrollPanel: { scrollingX: false },
          bar: { size: '6px', keepShow: true },
          rail: { gutterOfSide: '4px' },
        }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedCards.value, (card, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: card.id,
                          class: "view-card-wrap",
                          "data-card-id": (card || {}).id ?? ''
                        }, [
                          _createVNode(_unref(BoardListCard), {
                            "card-id": (card || {}).id ?? '',
                            index: index,
                            "list-cards": relatedCards.value,
                            layout: "list",
                            "drag-enabled": false,
                            "force-hide-drag-handle": true,
                            onCardMouseOver: () => {}
                          }, null, 8, ["card-id", "index", "list-cards"])
                        ], 8, _hoisted_4))
                      }), 128))
                    ], 512)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})